/**
 * @Author: Junaid Atari junaid.attari@invozone.dev
 * @Date: 2024-12-20 12:33:00
 * @LastEditors: Junaid Atari junaid.attari@invozone.dev
 * @LastEditTime: 2024-12-20 12:33:03
 * @FilePath: src/assets/images/hire-designer/pdf.tsx
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */
import React from 'react';

const PDF = () => {
  return (
    <>
      <svg
        width="33"
        height="33"
        viewBox="0 0 33 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M28.5492 31.7027H12.2346C10.1868 31.7027 8.52673 30.0426 8.52673 27.9948V5.00608C8.52673 2.95828 10.1868 1.29821 12.2346 1.29821H22.1241L32.2571 11.4312V27.9948C32.2571 30.0426 30.597 31.7027 28.5492 31.7027Z"
          fill="#EEF1F7"
          stroke="#CBD0DC"
          strokeWidth="1.48315"
        />
        <rect
          y="14.6465"
          width="22.2472"
          height="12.9775"
          rx="2.59551"
          fill="#D82042"
        />
        <path
          d="M3.6875 24.2862V18.084H5.89826C6.38079 18.084 6.78055 18.1718 7.09752 18.3475C7.4145 18.5231 7.65173 18.7634 7.80921 19.0682C7.96669 19.3711 8.04543 19.7123 8.04543 20.0918C8.04543 20.4734 7.96568 20.8166 7.80618 21.1215C7.6487 21.4244 7.41046 21.6646 7.09147 21.8423C6.77449 22.0179 6.37575 22.1058 5.89523 22.1058H4.37496V21.3123H5.81044C6.1153 21.3123 6.36262 21.2598 6.55241 21.1548C6.74219 21.0478 6.8815 20.9025 6.97033 20.7187C7.05916 20.535 7.10358 20.326 7.10358 20.0918C7.10358 19.8576 7.05916 19.6497 6.97033 19.468C6.8815 19.2863 6.74118 19.1439 6.54938 19.041C6.35959 18.938 6.10924 18.8865 5.79832 18.8865H4.62329V24.2862H3.6875Z"
          fill="white"
        />
        <path
          d="M11.1503 24.2862H9.14248V18.084H11.2139C11.8216 18.084 12.3435 18.2082 12.7796 18.4565C13.2157 18.7028 13.5499 19.0571 13.7821 19.5195C14.0163 19.9798 14.1334 20.532 14.1334 21.176C14.1334 21.8221 14.0152 22.3773 13.779 22.8417C13.5448 23.306 13.2056 23.6634 12.7615 23.9137C12.3173 24.1621 11.7803 24.2862 11.1503 24.2862ZM10.0783 23.4686H11.0989C11.5713 23.4686 11.964 23.3797 12.2769 23.202C12.5899 23.0224 12.8241 22.7629 12.9795 22.4237C13.135 22.0825 13.2127 21.6666 13.2127 21.176C13.2127 20.6895 13.135 20.2766 12.9795 19.9374C12.8261 19.5982 12.5969 19.3408 12.2921 19.1651C11.9872 18.9895 11.6086 18.9017 11.1564 18.9017H10.0783V23.4686Z"
          fill="white"
        />
        <path
          d="M15.297 24.2862V18.084H19.1431V18.8895H16.2328V20.7793H18.8676V21.5818H16.2328V24.2862H15.297Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default PDF;
